"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.informativeTypeToTitle = exports.informativeTypeToColor = void 0;
const component_translations_1 = require("./component-translations");
const informativeTypeToColor = (type) => {
    switch (type) {
        case 'tip': return 'green';
        case 'warning': return 'red';
        case 'important': return 'orange';
        case 'note': return 'blue';
        default: return 'green';
    }
};
exports.informativeTypeToColor = informativeTypeToColor;
const informativeTypeToTitle = (type, locale) => component_translations_1.componentTranslations[locale][type];
exports.informativeTypeToTitle = informativeTypeToTitle;
